import { useMeeting, useParticipant } from "@videosdk.live/react-sdk";
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player";
import MicWhiteOn from "interactive-live-streaming/components/icons/MicOnWhite.svg";
import MicWhiteOff from "interactive-live-streaming/components/icons/MicOffWhite.svg";
// import WiFiGreen from "./icons/Studentlist/WiFiGreen";
import { useMeetingAppContext } from "./MeetingAppContextDef";

export default function PopOverParticipantVideoRow({isPresenting, onClose}) {
  const {
    participants,
    pinnedParticipants,
    activeSpeakerId,
    localParticipant,
    localScreenShareOn,
    presenterId,
  } = useMeeting();
  const mMeeting = useMeeting(); // Assuming this hook exists

  const { meetingRecord } = useMeetingAppContext();
  
  const urlParams = new URLSearchParams(window.location.search);
  const sahUser = urlParams.get('sahUser');
  
  const currentSchoolId = sahUser === 'true' ? '17250' : "GTS";
  const [teacherActiveDevices, setTeacherActiveDevices] = useState({});
  const {showPeerVideos} = useMeetingAppContext()
  // Get all participant IDs
  const allParticipantIds = useMemo(() => {
    const pinnedParticipantId = [...pinnedParticipants.keys()].filter(
      (participantId) => {
        return participantId != localParticipant.id;
      }
    );
    const regularParticipantIds = [...participants.keys()].filter(
      (participantId) => {
        return (
          ![...pinnedParticipants.keys()].includes(participantId) &&
          localParticipant.id != participantId
        );
      }
    );

    const ids = [
    
      ...pinnedParticipantId,
      ...regularParticipantIds,
    ];

    if (activeSpeakerId) {
      if (!ids.includes(activeSpeakerId)) {
        ids[ids.length - 1] = activeSpeakerId;
      }
    }
    return ids;
  }, [
    participants,
    activeSpeakerId,
    pinnedParticipants,
    presenterId,
    localScreenShareOn,
  ]);
  
  // Filter participants based on school ID
  const visibleParticipantIds = useMemo(() => {
    console.log("sahhh school" , currentSchoolId);
    
    if (currentSchoolId == "17250"  && !showPeerVideos) {
      const teacherGroups = {};
      const nonTeacherIds = [];
      const localParticipantId = mMeeting.localParticipant?.id;
      
      allParticipantIds.forEach(id => {
        if (id === localParticipantId) {
          return;
        }
        
        if (id.includes("teacher")) {
          const uuid = id.split("teacher-")[0];
          
          if (!teacherGroups[uuid]) {
            teacherGroups[uuid] = [];
          }
          teacherGroups[uuid].push(id);
        } else {
          nonTeacherIds.push(id);
        }
      });
      
      const filteredTeacherIds = [];
      
      Object.entries(teacherGroups).forEach(([uuid, teacherIds]) => {
        const devicesWithCameraOn = teacherIds.filter(id => 
          mMeeting.participants.get(id)?.webcamOn
        );
        
        if (devicesWithCameraOn.length > 0) {
          filteredTeacherIds.push(devicesWithCameraOn[0]);
        } 
        else if (teacherActiveDevices[uuid] && teacherIds.includes(teacherActiveDevices[uuid])) {
          filteredTeacherIds.push(teacherActiveDevices[uuid]);
        }
        else {
          const deviceWithMicOn = teacherIds.find(id => 
            mMeeting.participants.get(id)?.micOn
          );
          
          if (deviceWithMicOn) {
            filteredTeacherIds.push(deviceWithMicOn);
          } else if (teacherIds.length > 0) {
            filteredTeacherIds.push(teacherIds[0]);
          }
        }
      });
      
      const visibleIds = [
        ...filteredTeacherIds
      ].filter(Boolean); 
      
      console.log("Filtered teacher participants:", visibleIds);
      return visibleIds;
    }

    return allParticipantIds;
  }, [allParticipantIds, currentSchoolId, showPeerVideos, mMeeting.localParticipant?.id, mMeeting.participants, teacherActiveDevices, ])

  // Audio-only participants (for school ID 17250)
  const audioOnlyParticipantIds = useMemo(() => {
    if (currentSchoolId == "17250") {
      // Get all non-teacher participants for audio-only rendering
      return allParticipantIds.filter(id => !id?.includes("teacher"));
    }
    return []; // No audio-only participants for other schools
  }, [allParticipantIds, currentSchoolId]);

  const { sideBarMode } = useMeetingAppContext();
 
  return (
    <div
      className="MainTopPan ParticipantRightShideCol"
         
    >
      <div className="ShareVideoThumbPannel">
        {/* Render visible participants (all participants or only teachers) */}
        {visibleParticipantIds.map((participantId) => (
          <VideoPopOver 
            key={`visible_${participantId}`} 
            participantId={participantId} 
            hiddenVideo={false}
          />
        ))}
        
        {/* Render audio-only participants (non-teachers for school ID 17250) */}
        {audioOnlyParticipantIds.map((participantId) => (
          <div key={`audio_only_${participantId}`} style={{ display: "none" }}>
            <VideoPopOver 
              participantId={participantId} 
              hiddenVideo={true}
              audioOnly={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function VideoPopOver({ participantId, hiddenVideo = false, audioOnly = false }) {
  const micRef = useRef(null);
  const {
    displayName,
    webcamStream,
    micStream,
    webcamOn,
    micOn,
    isLocal,
    mode,
    isActiveSpeaker,
    getVideoStats,
  } = useParticipant(participantId);

  const { selectedSpeaker } = useMeetingAppContext();

  console.log("OOOOOOOOOOOOOOOOOOOOOO",getVideoStats())
  useEffect(() => {
    const isFirefox =
      navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    if (micRef.current) {
      try {
        if (!isFirefox) {
          micRef.current.setSinkId(selectedSpeaker.id);
        }
      } catch(err) {
        console.log("Setting speaker device failed", err);
      }
    } 
  }, [selectedSpeaker]);

  useEffect(() => {
    console.log("micOnn",micOn);
    
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);
        micRef.current.srcObject = mediaStream;
        micRef.current
          .play()
          .catch((error) =>
            console.error("micRef.current.play() failed", error)
          );
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn, micRef]);

  const [networkStrength, setNetworkStrength] = useState(0);
  const {
    networkStrengthOfParticipants,
  } = useMeetingAppContext();
  
  useEffect(() => {
    if (networkStrengthOfParticipants && Array.isArray(networkStrengthOfParticipants) && networkStrengthOfParticipants?.length > 0) {
      const participant = networkStrengthOfParticipants.find((participant) => participant?.senderId === participantId);
      if (participant) {
        if (participant?.networkSpeed) {
          setNetworkStrength(participant?.networkSpeed);
        }
      }
    }
  }, [networkStrengthOfParticipants, participantId]);

  const webcamMediaStream = useMemo(() => {
    // Don't create video stream for audio-only participants or when video is hidden
    if (webcamOn && webcamStream && !hiddenVideo && !audioOnly) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }
    return null;
  }, [webcamStream, webcamOn, hiddenVideo, audioOnly]);

  const targetRef = useRef();

  const handlePauseStream = () => {
    if (webcamStream) {
      webcamStream.pause();
    }
  };

  const handleResumeStream = () => {
    if (webcamStream) {
      webcamStream.resume();
    }
  };

  // useEffect(() => {
  //   let observer;
  //   if (webcamMediaStream) {
  //     observer = new IntersectionObserver(
  //       ([entry]) => {
  //         if (entry.isIntersecting) {
  //           handleResumeStream();
  //         } else {
  //           handlePauseStream();
  //         }
  //       },
  //       {
  //         root: null,
  //         rootMargin: '0px',
  //         threshold: 0.5, 
  //       }
  //     );

  //     if (targetRef.current) {
  //       observer.observe(targetRef.current);
  //     }
  //   }

  //   return () => {
  //     if (targetRef.current && observer) {
  //       if(webcamStream){
  //         webcamStream.resume();
  //       }
  //       observer.unobserve(targetRef.current);
  //     }
  //   };
  // }, [webcamMediaStream]);

  // If audio-only participant, only render audio element
  if (audioOnly) {
    return (
      <audio 
        ref={micRef} 
        autoPlay 
        muted={isLocal} 
        data-participant-id={participantId}
      />
    );
  }
  console.log(webcamOn , webcamStream, "webcamMediaStreammmmmmm");


  return (
    <div 
      ref={targetRef}
      className={`parcipantVideoThumbContainer ${isActiveSpeaker && micOn ? "ActiveBorder" : ""}`}
    >
      <audio ref={micRef} autoPlay muted={isLocal} />
      {webcamOn && !hiddenVideo ? (
        <>
          <ReactPlayer
            playsinline
            playIcon={<></>}
            pip={false}
            light={false}
            controls={false}
            muted={true}
            playing={true}
            url={webcamMediaStream}
            height={"100%"}
            width={"100%"}
            onError={(err) => {
              console.log(err, "participant video error");
            }}
          />
          <div className="VideoBottomBar">
            <div className="VideoBottomBarLeft">
              <div className="MicIcon">
                {micOn ? 
                  <img src={MicWhiteOn} alt="MicWhiteOn"/> : 
                  <img src={MicWhiteOff} alt="MicWhiteOff"/>
                }
              </div>
              <div className="parcipateName">
                {displayName}
              </div>
            </div>
            <div></div>
          </div>
        </>
      ) : (
        <div className="parcipantVideoThumb">
          <div className="NoVedioOn">  
            {micOn ? 
              <div className="owalBox RippleEffect">
                {displayName?.charAt(0)}
              </div> : 
              <div className="owalBox">
                {displayName?.charAt(0)}
              </div>
            }
          </div>
          <div className="VideoBottomBar">
            <div className="VideoBottomBarLeft">
              <div className="MicIcon">
                {micOn ? 
                  <img src={MicWhiteOn} alt="MicWhiteOn"/> : 
                  <img src={MicWhiteOff} alt="MicWhiteOff"/>
                }
              </div>
              <div className="parcipateName">
                {displayName}
              </div>
            </div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
}